import { getToken, setToken, removeToken } from '@/utils/auth';
import Cookies from 'js-cookie';
import api from '@/provider/api'

const user = {
	state: {
		token: getToken(),
		userInfo:null
	},
	mutations: {
		SET_TOKEN: (state, token) => {
			state.token = token;
		},
		SET_USERINFO: (state, userInfo) => {
			state.userInfo = userInfo;
		},
	},
	actions: {
		// 登录
		Login({ commit }, form) {
			return new Promise((resolve, reject) => {
				api.user.login(form)
					.then(res => {
						if (res.msgType=='success') {
			        		setToken(res.data.TOKEN);
							commit('SET_TOKEN', res.data.TOKEN);
			        	}
						resolve();
					}).catch(error => {
						reject(error);
					});
			});
		},

	    // 获取用户信息
	    GetUserInfo({ commit, state }) {
			return new Promise((resolve, reject) => {
				api.user.getUserInfo(getToken())
		        	.then(res => {
			         	if (res.msgType!='') {
			        		reject(res.msg)
			        	}
						commit('SET_USERINFO', res.data);
			        	resolve(res);
				}).catch(error => {
		       		reject(error)
				})
			})
	    },

        // 前端 登出
		FedLogOut({ commit }) {
			return new Promise(resolve => {
				commit('SET_TOKEN', '')
				removeToken();
				resolve();
			})
		},

		// 登出
		Logout({ commit, state }) {
			return new Promise((resolve, reject) => {
				api.user.logOut(state.token).then(() => {
					commit('SET_TOKEN', '')
					removeToken()
					resolve()
				}).catch(error => {
					reject(error)
				})
			})
		},

	},
};

export default user;
